var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:['gl-icon', _vm.iconClass, _vm.iconClosed, { unactiveBorder: _vm.extraStyle }, { activeBorder: _vm.extraStyle }],style:({ fontSize: _vm.fontSize }),attrs:{"aria-hidden":"true","preserveAspectRatio":"none meet"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }